export var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/units/constants.js
// module id = 94
// module chunks = 3